/* cache-bump aug12 — forces a fresh asset version so all CDN edges serve the current file. No code changes. */
/* ============================================
   ALANKAR JEWELLERS — HEADER JS
   Matches alankar-header-COMPLETE.html exactly
   Adapted for Shopify: Predictive Search API + pubsub cart
   ============================================ */

(function () {
  'use strict';

  /* ============================================
     ANNOUNCEMENT ROTATOR
     ============================================ */
  (function () {
    var rotator = document.getElementById('alk-announce-rotator');
    if (!rotator) return;
    var items = rotator.querySelectorAll('.alk-announce-item');
    if (items.length < 2) return;
    var current = 0;
    setInterval(function () {
      items[current].classList.remove('active');
      current = (current + 1) % items.length;
      items[current].classList.add('active');
    }, 4000);
  })();

  /* ============================================
     MOBILE DRAWER
     ============================================ */
  (function () {
    var drawer = document.getElementById('alk-mobile-drawer');
    var overlay = document.getElementById('alk-drawer-overlay');
    var closeBtn = document.getElementById('alk-drawer-close');
    var menuBtn = document.getElementById('alk-menu-btn');
    if (!drawer || !overlay) return;

    function openDrawer() {
      drawer.classList.add('open');
      overlay.classList.add('open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('alk-no-scroll');
    }
    function closeDrawer() {
      drawer.classList.remove('open');
      overlay.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('alk-no-scroll');
      document.querySelectorAll('.alk-mobile-nav-item.open').forEach(function (item) {
        item.classList.remove('open');
        var trigger = item.querySelector('.alk-mobile-nav-trigger');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
    }

    if (menuBtn) menuBtn.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('open')) closeDrawer();
    });

    /* Accordion */
    document.querySelectorAll('[data-nav-item] .alk-mobile-nav-trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.parentElement;
        var isOpen = item.classList.contains('open');
        // Close siblings
        item.parentElement.querySelectorAll('.alk-mobile-nav-item.open').forEach(function (sib) {
          if (sib !== item) {
            sib.classList.remove('open');
            var sibTrigger = sib.querySelector('.alk-mobile-nav-trigger');
            if (sibTrigger) sibTrigger.setAttribute('aria-expanded', 'false');
          }
        });
        item.classList.toggle('open', !isOpen);
        trigger.setAttribute('aria-expanded', String(!isOpen));
      });
    });
  })();

  /* ============================================
     SEARCH OVERLAY — grid results, filters, sort, add-to-bag, wishlist
     ============================================ */
  (function () {
    var overlay = document.getElementById('alk-search-overlay');
    var input = document.getElementById('alk-search-input');
    if (!overlay || !input) return;

    var closeBtn = document.getElementById('alk-search-close');
    var clearBtn = document.getElementById('alk-search-clear');
    var iconBtn = document.getElementById('alk-search-icon-btn');
    var grid = document.getElementById('alk-sr-grid');
    var countEl = document.getElementById('alk-sr-count');
    var countN = document.getElementById('alk-sr-count-n');
    var countWord = document.getElementById('alk-sr-count-word');
    var viewAll = document.getElementById('alk-sr-viewall');
    var toolbar = document.getElementById('alk-sr-toolbar');
    var chipsEl = document.getElementById('alk-sr-chips');
    var sortEl = document.getElementById('alk-sr-sort');
    var emptyEl = document.getElementById('alk-search-empty');
    var emptyQueryEl = document.getElementById('alk-search-empty-query');
    var recentEl = document.getElementById('alk-search-recent');
    var recentListEl = document.getElementById('alk-search-recent-list');
    var cartBadge = document.getElementById('alk-cart-count');

    var WL_KEY = 'alkWishlist';
    var rawResults = [];
    var recentSearches = [];
    var activeFilter = { type: 'all' };
    var sortMode = 'relevance';
    var debounceTimer = null;
    var lastQuery = '';

    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function highlight(t, q) {
      var s = esc(t);
      if (!q) return s;
      var qq = q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      try { return s.replace(new RegExp('(' + qq + ')', 'gi'), '<mark>$1</mark>'); } catch (e) { return s; }
    }
    function num(v) { if (v == null) return NaN; if (typeof v === 'number') return v; return parseFloat(String(v).replace(/[^0-9.]/g, '')); }
    function price(v) {
      var n = num(v);
      if (isNaN(n)) return '';
      return 'Rs. ' + Number(n).toLocaleString('en-IN', { maximumFractionDigits: 0 });
    }
    function wl() { try { return JSON.parse(localStorage.getItem(WL_KEY) || '[]'); } catch (e) { return []; } }
    function wlSave(a) { try { localStorage.setItem(WL_KEY, JSON.stringify(a)); } catch (e) {} }

    function fetchResults(query) {
      var base = (window.routes && window.routes.predictive_search_url) ? window.routes.predictive_search_url : '/search/suggest';
      if (base.indexOf('.json') === -1) base = base.replace(/\/+$/, '') + '.json';
      var url = base + '?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last';
      return fetch(url).then(function (r) { return r.json(); }).then(function (d) {
        return (d.resources && d.resources.results && d.resources.results.products) || [];
      }).catch(function () { return []; });
    }

    function categoryChips() {
      var types = {}; var order = [];
      rawResults.forEach(function (p) { var t = (p.product_type || '').trim(); if (t && !types[t]) { types[t] = 1; order.push(t); } });
      return order.slice(0, 3);
    }
    function sameFilter(a, b) { return a.type === b.type && (a.val || '') === (b.val || '') && (a.max || 0) === (b.max || 0); }

    function buildChips() {
      var chips = [
        { label: 'All', f: { type: 'all' } },
        { label: 'In Stock', f: { type: 'instock' } },
        { label: 'Under ₹2,000', f: { type: 'price', max: 2000 } }
      ];
      categoryChips().forEach(function (t) { chips.push({ label: t, f: { type: 'cat', val: t } }); });
      chipsEl._chips = chips;
      chipsEl.innerHTML = chips.map(function (c, i) {
        return '<button type="button" class="alk-sr-chip' + (sameFilter(c.f, activeFilter) ? ' active' : '') + '" data-i="' + i + '">' + esc(c.label) + '</button>';
      }).join('');
      Array.prototype.forEach.call(chipsEl.querySelectorAll('.alk-sr-chip'), function (b) {
        b.addEventListener('click', function () { activeFilter = chipsEl._chips[+b.dataset.i].f; buildChips(); renderGrid(); });
      });
    }

    function applyFilter(list) {
      return list.filter(function (p) {
        if (activeFilter.type === 'instock') return p.available !== false;
        if (activeFilter.type === 'price') return !isNaN(num(p.price)) && num(p.price) < activeFilter.max;
        if (activeFilter.type === 'cat') return (p.product_type || '') === activeFilter.val;
        return true;
      });
    }
    function applySort(list) {
      var a = list.slice();
      if (sortMode === 'price-asc') a.sort(function (x, y) { return num(x.price) - num(y.price); });
      else if (sortMode === 'price-desc') a.sort(function (x, y) { return num(y.price) - num(x.price); });
      return a;
    }

    function cardHTML(p) {
      var img = (p.featured_image && p.featured_image.url) ? p.featured_image.url : (p.image || '');
      if (img) img = img.replace(/(\.(jpg|jpeg|png|gif|webp))(\?|$)/i, '_400x500$1$3');
      var onSale = p.compare_at_price && p.price && num(p.compare_at_price) > num(p.price);
      var liked = wl().indexOf(p.handle) > -1;
      return '<article class="alk-srcard" data-handle="' + esc(p.handle) + '" data-available="' + (p.available !== false) + '" data-type="' + esc(p.product_type || '') + '" data-price="' + (p.price || 0) + '">' +
        '<div class="alk-srcard-media">' +
          (onSale ? '<span class="alk-sr-tag">Sale</span>' : '') +
          '<button type="button" class="alk-sr-wish' + (liked ? ' liked' : '') + '" aria-label="Save"><svg viewBox="0 0 24 24"><path d="M12 21s-7-4.5-9.5-9C1 9 2.5 5.5 6 5.5c2 0 3.2 1.3 4 2.5.8-1.2 2-2.5 4-2.5 3.5 0 5 3.5 3.5 6.5C19 16.5 12 21 12 21z"/></svg></button>' +
          '<a class="alk-srcard-link" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" loading="lazy" alt="' + esc(p.title) + '">' : '') + '</a>' +
          '<button type="button" class="alk-sr-add" aria-label="Add to bag"><svg viewBox="0 0 24 24"><path d="M12 5v14M5 12h14"/></svg><span class="alk-sr-add-t">Add to Bag</span></button>' +
        '</div>' +
        '<a class="alk-srcard-info" href="' + esc(p.url) + '">' +
          (p.product_type ? '<div class="alk-srcard-cat">' + esc(p.product_type) + '</div>' : '') +
          '<div class="alk-srcard-name">' + highlight(p.title, lastQuery) + '</div>' +
          '<div class="alk-srcard-price">' + price(p.price) + (onSale ? '<span class="mrp">' + price(p.compare_at_price) + '</span>' : '') + '</div>' +
        '</a>' +
      '</article>';
    }

    function renderGrid() {
      var list = applySort(applyFilter(rawResults));
      grid.innerHTML = list.map(cardHTML).join('');
      if (countN) countN.textContent = list.length;
      if (countWord) countWord.textContent = list.length === 1 ? 'piece' : 'pieces';
      bindCards();
    }

    function bindCards() {
      Array.prototype.forEach.call(grid.querySelectorAll('.alk-sr-wish'), function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          var card = b.closest('.alk-srcard'); var h = card.dataset.handle;
          var a = wl(); var i = a.indexOf(h);
          if (i > -1) { a.splice(i, 1); b.classList.remove('liked'); } else { a.push(h); b.classList.add('liked'); }
          wlSave(a);
        });
      });
      Array.prototype.forEach.call(grid.querySelectorAll('.alk-sr-add'), function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          var card = b.closest('.alk-srcard'); var h = card.dataset.handle;
          var t = b.querySelector('.alk-sr-add-t'); var orig = t ? t.textContent : '';
          if (t) t.textContent = 'Adding…';
          fetch('/products/' + h + '.js').then(function (r) { return r.json(); }).then(function (prod) {
            var vs = prod.variants || [];
            var v = vs.filter(function (x) { return x.available; })[0] || vs[0];
            if (!v) { if (t) t.textContent = orig; return; }
            return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: v.id, quantity: 1 }) })
              .then(function (r) { return r.json(); })
              .then(function () { if (t) t.textContent = '✓ Added'; refreshCart(); setTimeout(function () { if (t) t.textContent = orig; }, 1400); });
          }).catch(function () { if (t) t.textContent = orig; });
        });
      });
    }

    function refreshCart() {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
        if (cartBadge) { if (c.item_count > 0) { cartBadge.textContent = c.item_count; cartBadge.style.display = ''; } else { cartBadge.style.display = 'none'; } }
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        try { if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'alk-search' }); } } catch (e) {}
      }).catch(function () {});
    }

    function showResultsUI(show) {
      if (countEl) countEl.hidden = !show;
      if (toolbar) toolbar.hidden = !show;
      if (grid) grid.style.display = show ? '' : 'none';
    }

    function renderRecent() {
      if (!recentEl || !recentListEl) return;
      if (recentSearches.length === 0) { recentEl.classList.remove('visible'); return; }
      recentEl.classList.add('visible');
      recentListEl.innerHTML = recentSearches.map(function (q) {
        return '<button type="button" class="alk-search-recent-chip" data-q="' + esc(q) + '"><svg viewBox="0 0 24 24"><path d="M12 8v4l3 2"/><circle cx="12" cy="12" r="10"/></svg>' + esc(q) + '</button>';
      }).join('');
      Array.prototype.forEach.call(recentListEl.querySelectorAll('.alk-search-recent-chip'), function (c) {
        c.addEventListener('click', function () { input.value = c.dataset.q; onInput(); });
      });
    }
    function addRecent(q) {
      q = (q || '').trim(); if (!q) return;
      recentSearches = recentSearches.filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
      recentSearches.unshift(q);
      if (recentSearches.length > 5) recentSearches = recentSearches.slice(0, 5);
    }

    function doSearch(query) {
      lastQuery = query;
      if (!query.trim()) {
        overlay.classList.remove('is-searching');
        rawResults = []; if (grid) grid.innerHTML = ''; showResultsUI(false);
        if (emptyEl) emptyEl.classList.remove('visible');
        renderRecent();
        return;
      }
      overlay.classList.add('is-searching');
      fetchResults(query).then(function (products) {
        rawResults = products;
        if (viewAll) viewAll.href = '/search?q=' + encodeURIComponent(query) + '&type=product';
        if (products.length === 0) {
          showResultsUI(false);
          if (grid) grid.innerHTML = '';
          if (emptyQueryEl) emptyQueryEl.textContent = query;
          if (emptyEl) emptyEl.classList.add('visible');
          return;
        }
        if (emptyEl) emptyEl.classList.remove('visible');
        activeFilter = { type: 'all' };
        showResultsUI(true);
        buildChips();
        renderGrid();
      });
    }

    function onInput() {
      var v = input.value;
      if (clearBtn) clearBtn.classList.toggle('visible', v.length > 0);
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () { doSearch(v); }, 220);
    }

    function openSearch() {
      overlay.classList.add('open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.classList.add('alk-no-scroll');
      setTimeout(function () { input.focus(); }, 180);
      renderRecent();
    }
    function closeSearch() {
      overlay.classList.remove('open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('alk-no-scroll');
    }

    if (iconBtn) iconBtn.addEventListener('click', openSearch);
    if (closeBtn) closeBtn.addEventListener('click', closeSearch);
    input.addEventListener('input', onInput);
    if (clearBtn) clearBtn.addEventListener('click', function () { input.value = ''; onInput(); input.focus(); });
    if (sortEl) sortEl.addEventListener('change', function () { sortMode = sortEl.value; renderGrid(); });
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeSearch(); });
    var form = overlay.querySelector('.alk-search-form');
    if (form) form.addEventListener('submit', function () { addRecent(input.value); });
    document.querySelectorAll('.alk-search-suggestion').forEach(function (s) {
      s.addEventListener('click', function () { input.value = s.dataset.query || s.textContent; input.focus(); onInput(); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('open')) {
        if (input.value) { input.value = ''; onInput(); } else { closeSearch(); }
      }
    });
  })();

  /* ============================================
     CART COUNT — subscribe to Shopify pubsub
     ============================================ */
  (function () {
    var badge = document.getElementById('alk-cart-count');
    if (!badge) return;

    function updateBadge(count) {
      if (count > 0) {
        badge.textContent = count;
        badge.style.display = '';
      } else {
        badge.style.display = 'none';
      }
    }

    /* Shopify pubsub (Dawn theme) */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) {
        if (e && e.cart) updateBadge(e.cart.item_count);
      });
    }

    /* Fallback: poll cart JSON on page focus */
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') {
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) { updateBadge(cart.item_count); })
          .catch(function () {});
      }
    });
  })();

})();

/* ============================================================
   PROFILE ICON → GOKWIK KWIKPASS OTP LOGIN (Jul 30, restored)
   WHY THIS EXISTS: GoKwik's own account-gate intercepts the
   profile icon click but its popup call (kp_trigger_popup /
   open_login_autoload) no-ops because the login popup config is
   missing on GoKwik's merchant backend (ticket raised with their
   support). kpHandleLogin() works and opens the OTP popup on the
   SAME page — verified with real trusted user input.
   Approach: rewire the account links at load time — strip href
   (stored in data attribute) so neither the browser nor GoKwik's
   delegated gate can act on it, and bind our own handler that
   calls kpHandleLogin(). Retry: fire, wait 2.5s for #iframe-kp,
   max 3 tries, then fall back to the original login URL.
   Covers /account/login AND /customer_authentication (Shopify
   new customer accounts). Logged-in customers (href=/account)
   are untouched. Remove this block once GoKwik fixes their
   backend popup config, if native behavior is preferred.
   ============================================================ */
(function () {
  var kpBusy = false;

  function popupVisible() {
    var f = document.getElementById('iframe-kp');
    if (!f) return false;
    var cs = getComputedStyle(f);
    return cs.display !== 'none' && cs.visibility !== 'hidden' && f.getBoundingClientRect().width > 50;
  }

  function fireKwikPass() {
    if (typeof window.kpHandleLogin === 'function') {
      try { window.kpHandleLogin(); return true; } catch (e) {}
    }
    if (typeof window.kp_trigger_popup === 'function') {
      try { window.kp_trigger_popup(false); return true; } catch (e) {}
    }
    return false;
  }

  function openKwikPass(fallbackHref) {
    if (kpBusy) return;
    kpBusy = true;
    var attempts = 0;
    (function attempt() {
      attempts++;
      if (!popupVisible()) fireKwikPass();
      setTimeout(function () {
        if (popupVisible()) { kpBusy = false; return; }
        if (attempts < 3) { attempt(); }
        else {
          kpBusy = false;
          if (fallbackHref) window.location.href = fallbackHref;
        }
      }, 2500);
    })();
  }

  function rewire() {
    var links = document.querySelectorAll('a[href*="/account/login"], a[href*="/customer_authentication"]');
    Array.prototype.forEach.call(links, function (a) {
      if (a.getAttribute('data-kp-wired')) return;
      a.setAttribute('data-kp-wired', '1');
      var href = a.getAttribute('href');
      a.setAttribute('data-kp-href', href);
      a.removeAttribute('href'); /* GoKwik's delegated gate + browser nav can no longer act on it */
      a.style.cursor = 'pointer';
      a.setAttribute('role', 'button');
      a.setAttribute('tabindex', '0');
      a.addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        openKwikPass(a.getAttribute('data-kp-href'));
      });
      a.addEventListener('keydown', function (ev) {
        if (ev.key === 'Enter' || ev.key === ' ') {
          ev.preventDefault();
          openKwikPass(a.getAttribute('data-kp-href'));
        }
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', rewire);
  else rewire();
  /* catch late-rendered links (sections load after first paint) */
  setTimeout(rewire, 1200);
  setTimeout(rewire, 3000);
})();

/* Open the cart drawer after a /cart redirect (see sections/alankar-cart-redirect.liquid) */
(function(){
  try {
    if (sessionStorage.getItem('mynaOpenCart')) {
      sessionStorage.removeItem('mynaOpenCart');
      var open = function(){ if (window.mynaOpenCart) { window.mynaOpenCart(); } else { setTimeout(open, 150); } };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', open); else open();
    }
  } catch (e) {}
})();

/* ============================================================
   BFCACHE FIX — Close all overlays when page is restored
   from the browser's back-forward cache.
   ============================================================ */
window.addEventListener('pageshow', function (event) {
  if (!event.persisted) return;
  var searchOverlay = document.getElementById('alk-search-overlay');
  if (searchOverlay) {
    searchOverlay.classList.remove('open');
    searchOverlay.setAttribute('aria-hidden', 'true');
  }
  var mobileDrawer = document.getElementById('alk-mobile-drawer');
  var drawerOverlay = document.getElementById('alk-drawer-overlay');
  if (mobileDrawer) {
    mobileDrawer.classList.remove('open');
    mobileDrawer.setAttribute('aria-hidden', 'true');
  }
  if (drawerOverlay) drawerOverlay.classList.remove('open');
  var cartOverlay = document.querySelector('.alk-cart-drawer-overlay, .alk-cart-overlay');
  if (cartOverlay) cartOverlay.classList.remove('open');
  document.body.classList.remove('alk-no-scroll');
});

/* ============================================
   SHOP MEGA — hover-to-swap image preview
   ============================================ */
(function () {
  var shopRows = document.querySelectorAll('.alk-shop-row');
  var shopLayers = document.querySelectorAll('.alk-shop-pv');
  if (!shopRows.length || !shopLayers.length) return;

  shopRows.forEach(function (r) {
    r.addEventListener('mouseenter', function () {
      var k = +r.dataset.k;
      shopRows.forEach(function (x) { x.classList.remove('alk-shop-active'); });
      r.classList.add('alk-shop-active');
      shopLayers.forEach(function (l) {
        l.classList.toggle('on', +l.dataset.k === k);
      });
    });
  });
})();

/* ============================================
   SHOP MEGA — viewport-clamp positioning
   Centers mega on SHOP item but clamps to screen
   so Collections column never clips off-left.
   ============================================ */
(function () {
  var shopMega = document.querySelector('.alk-shop-mega');
  if (!shopMega) return;
  var shopLi = shopMega.parentElement;
  if (!shopLi) return;

  function positionMega() {
    var liRect = shopLi.getBoundingClientRect();
    var vw = window.innerWidth;
    var megaW = Math.min(1060, vw - 32);
    /* Ideal center-aligned position */
    var ideal = liRect.left + liRect.width / 2 - megaW / 2;
    /* Clamp: 16px left padding, 16px right padding */
    var clamped = Math.max(16, Math.min(ideal, vw - megaW - 16));
    /* Convert from viewport coord to li-relative offset */
    shopMega.style.left = (clamped - liRect.left) + 'px';
    shopMega.style.width = megaW + 'px';
  }

  shopLi.addEventListener('mouseenter', positionMega);
  window.addEventListener('resize', function () {
    if (shopLi.matches(':hover')) positionMega();
  });
})();
